import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API, colors } from "../shared/constants";
import { styles } from "../shared/styles";
import { useIsMobile } from "../shared/utils";
import { LuTrash2 } from "react-icons/lu";

const formatDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-AU", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

// Receipts field techs have sent in for reimbursement.
//
// A collection point, not a ledger: there is no status to move a receipt
// through, because reimbursement happens outside the app and a workflow here
// would only be one more thing to keep in step with reality. Work from the top,
// pay it, delete it.
export function ReceiptsInbox() {
  const isMobile = useIsMobile();
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [viewing, setViewing] = useState(null);

  const load = useCallback(() => {
    axios
      .get(`${API}/receipts/`)
      .then((res) => {
        setReceipts(res.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  const remove = (id) => {
    axios
      .delete(`${API}/receipts/${id}/`)
      .then(() => {
        setConfirmDelete(null);
        load();
      })
      .catch(() => setConfirmDelete(null));
  };

  const q = search.toLowerCase();
  const visible = receipts.filter(
    (r) =>
      (r.submitted_by_name || "").toLowerCase().includes(q) ||
      (r.note || "").toLowerCase().includes(q),
  );

  return (
    <div>
      <div style={styles.topbar}>
        <div style={styles.pageTitle}>Receipts Inbox</div>
      </div>
      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.searchBar}>
            <input
              style={{ ...styles.searchInput, maxWidth: isMobile ? "100%" : "50%" }}
              placeholder="Search by tech or what it was for..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {loading ? (
            <div style={styles.loading}>Loading...</div>
          ) : visible.length === 0 ? (
            <div style={styles.loading}>
              {search
                ? "No receipts match your search."
                : "No receipts submitted yet."}
            </div>
          ) : (
            <>
              {visible.map((r) => (
                <div
                  key={r.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    padding: "12px 16px",
                    borderBottom: `1px solid ${colors.border}`,
                  }}
                >
                  {r.photo_url && (
                    <img
                      src={r.photo_url}
                      alt="Receipt"
                      onClick={() => setViewing(r)}
                      style={{
                        width: "56px",
                        height: "56px",
                        objectFit: "cover",
                        borderRadius: "6px",
                        border: `1px solid ${colors.border}`,
                        cursor: "pointer",
                        flexShrink: 0,
                      }}
                    />
                  )}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: "500", color: colors.text, fontSize: "14px" }}>
                      {r.submitted_by_name || "Unknown"}
                    </div>
                    <div style={{ fontSize: "13px", color: colors.slate, marginTop: "2px" }}>
                      {r.note || <span style={{ color: "#ccc" }}>No note</span>}
                    </div>
                    <div style={{ fontSize: "11px", color: "#aaa", marginTop: "2px" }}>
                      {formatDate(r.created_at)}
                    </div>
                  </div>
                  <a
                    href={r.photo_url}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      padding: "5px 12px",
                      borderRadius: "6px",
                      border: `1px solid ${colors.border}`,
                      color: colors.slate,
                      fontSize: "12px",
                      fontWeight: "600",
                      textDecoration: "none",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Open
                  </a>
                  <button
                    onClick={() =>
                      confirmDelete === r.id ? remove(r.id) : setConfirmDelete(r.id)
                    }
                    onBlur={() => confirmDelete === r.id && setConfirmDelete(null)}
                    title={confirmDelete === r.id ? "Click again to confirm" : "Delete"}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      // Grey until armed, and grey when armed: deleting a
                      // reimbursed receipt is routine housekeeping.
                      color: colors.slate,
                      fontSize: confirmDelete === r.id ? "11px" : "inherit",
                      fontWeight: "600",
                      padding: "4px",
                    }}
                  >
                    {confirmDelete === r.id ? "Delete?" : <LuTrash2 size={15} />}
                  </button>
                </div>
              ))}
              <div style={styles.count}>
                {visible.length} Receipt{visible.length !== 1 ? "s" : ""}
              </div>
            </>
          )}
        </div>
      </div>

      {viewing && (
        <div
          onClick={() => setViewing(null)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            zIndex: 1000,
            cursor: "pointer",
          }}
        >
          <img
            src={viewing.photo_url}
            alt="Receipt"
            style={{ maxWidth: "100%", maxHeight: "100%", borderRadius: "8px" }}
          />
        </div>
      )}
    </div>
  );
}
